import * as yup from 'yup';

export const FundWaterfallType = {
  FormBased: 'form-based',
  FormulaBased: 'formula-based',
} as const;
export type FundWaterfallType = (typeof FundWaterfallType)[keyof typeof FundWaterfallType];

export const ClientConfigKey = {
  AllowFundWaterfall: 'Allow_Fund_Waterfall',
  UsingConsolidatedDataCollection: 'Using_Consolidated_Data_Collection',
  FundWaterfallType: 'Fund_Waterfall_Type',
  CollectionOnly: 'Collection_Only',
  ForexAllCompaniesEnabled: 'FOREX_ALL_COMPANIES_ENABLED',
  UsingLedger: 'Using_Ledger',
  ShowAumniData: 'Show_Aumni_Data',
} as const;
export type ClientConfigKey = (typeof ClientConfigKey)[keyof typeof ClientConfigKey];

export function clientConfigFields() {
  return {
    id: yup.number().required(),
    key: yup.string().oneOf(Object.values(ClientConfigKey)).required(),
    value: yup.string().nullable(),
    type: yup.string().oneOf(['boolean', 'string', 'number']).required().default('string'),
  };
}

export function clientConfigFieldSchema() {
  return yup.object(clientConfigFields()).default([
    {
      id: 0,
      key: ClientConfigKey.AllowFundWaterfall,
      value: true,
      type: 'boolean',
    },
    {
      id: 1,
      key: ClientConfigKey.UsingConsolidatedDataCollection,
      value: false,
      type: 'boolean',
    },
    {
      id: 2,
      key: ClientConfigKey.CollectionOnly,
      value: false,
      type: 'boolean',
    },
    {
      id: 3,
      key: ClientConfigKey.FundWaterfallType,
      value: FundWaterfallType.FormBased,
      type: 'string',
    },
    {
      id: 4,
      key: ClientConfigKey.ForexAllCompaniesEnabled,
      value: false,
      type: 'boolean',
    },
    {
      id: 5,
      key: ClientConfigKey.ShowAumniData,
      value: true,
      type: 'boolean',
    },
    {
      id: 6,
      key: ClientConfigKey.UsingLedger,
      value: false,
      type: 'boolean',
    },
  ]);
}
export type ClientConfigField = yup.InferType<ReturnType<typeof clientConfigFieldSchema>>;

export function appClientConfigSchema() {
  return yup.array().of(clientConfigFieldSchema());
}
export type AppClientConfig = yup.InferType<ReturnType<typeof appClientConfigSchema>>;

export function parseClientConfig(config: AppClientConfig = []) {
  return config.reduce(
    (acc, item) => {
      if (item.type === 'boolean' || item.type === 'number') {
        acc[item.key] = JSON.parse(item.value ?? 'null');
      } else {
        acc[item.key] = item.value;
      }
      return acc;
    },
    {} as Record<ClientConfigKey, unknown>
  );
}
